import getDecryptedToken from "../../../../api/getDecryptedToken";

export type LoggedInClinic = {
  clinicName: string;
  address: string;
  tpNo: string;
  phoneTwo: string;
  website: string;
  email: string;
  printImages: string;
  drName: string;
};

const PLACEHOLDER_VALUES = new Set([
  "",
  "clinicName",
  "12454",
  "0771234567",
  "docto1 james",
]);

export function isRealClinicValue(value?: string | null): boolean {
  const v = String(value ?? "").trim();
  if (!v) return false;
  return !PLACEHOLDER_VALUES.has(v);
}

function pick(...values: Array<string | undefined | null>): string {
  for (const value of values) {
    if (isRealClinicValue(value)) return String(value).trim();
  }
  return "";
}

export function getLoggedInClinicFromSession(): LoggedInClinic {
  const clinicName = getDecryptedToken("clinicName");
  const title = getDecryptedToken("title");
  const phone = getDecryptedToken("clinicPhoneNumber");
  const userName = getDecryptedToken("userName");

  return {
    clinicName: pick(title, clinicName),
    address: pick(getDecryptedToken("address")),
    tpNo: pick(phone),
    phoneTwo: pick(phone),
    website: "",
    email: "",
    printImages: pick(getDecryptedToken("printImage"), getDecryptedToken("clinicLogo")),
    drName: pick(userName),
  };
}

export function clinicFromBillData(bill?: any): Partial<LoggedInClinic> {
  if (!bill) return {};
  return {
    clinicName: pick(bill.title, bill.clinicName),
    address: pick(bill.address),
    tpNo: pick(bill.tpNo),
    phoneTwo: pick(bill.tpNo2, bill.tpNo),
    website: pick(bill.website),
    email: pick(bill.email),
    printImages: pick(bill.printImages, bill.logoimage, bill.logo),
  };
}

export function clinicFromPrintState(clinic?: any): Partial<LoggedInClinic> {
  if (!clinic) return {};
  return {
    clinicName: pick(clinic.clinicName),
    address: pick(clinic.address),
    tpNo: pick(clinic.tpNo),
    phoneTwo: pick(clinic.phoneTwo, clinic.tpNo),
    website: pick(clinic.website),
    email: pick(clinic.email),
    printImages: pick(clinic.printImages),
    drName: pick(clinic.drName),
  };
}

export function mergeLoggedInClinic(
  ...sources: Array<Partial<LoggedInClinic> | null | undefined>
): LoggedInClinic {
  const merged: LoggedInClinic = {
    clinicName: "",
    address: "",
    tpNo: "",
    phoneTwo: "",
    website: "",
    email: "",
    printImages: "",
    drName: "",
  };
  for (const source of sources) {
    if (!source) continue;
    (Object.keys(merged) as Array<keyof LoggedInClinic>).forEach((key) => {
      const value = source[key];
      if (isRealClinicValue(value)) merged[key] = String(value).trim();
    });
  }
  if (!merged.phoneTwo && merged.tpNo) merged.phoneTwo = merged.tpNo;
  return merged;
}

export function resolveLoggedInClinic(bill?: any, printClinic?: any): LoggedInClinic {
  return mergeLoggedInClinic(
    getLoggedInClinicFromSession(),
    clinicFromBillData(bill),
    clinicFromPrintState(printClinic)
  );
}
